const main = () => {
    if (document.querySelector('.c-others-select-site') == null) return;

    // サイトモード切替
    document.querySelectorAll('.c-others-select-site').forEach((obj) => {
        obj.querySelector('form select[name="key"]').addEventListener('change', (e) => {
            const formObj = e.currentTarget.closest('form');
            formObj.submit();
        });
    });
}

export default main;